import type { PerformanceStats } from '../../types'

export const getStreakLabel = (stats: PerformanceStats | null | undefined) => {
  if (!stats) return '—'
  if (stats.current_win_streak > 0) return `${stats.current_win_streak}W`
  if (stats.current_loss_streak > 0) return `${stats.current_loss_streak}L`
  return '—'
}

// `dark:` variants apply only on the Dashboard's dark terminal theme.
export const getStreakColor = (stats: PerformanceStats | null | undefined) => {
  if (!stats) return 'text-gray-900 dark:text-gray-100'
  if (stats.current_win_streak > 0) return 'text-success-600 dark:text-green-400'
  if (stats.current_loss_streak > 0) return 'text-danger-600 dark:text-red-400'
  return 'text-gray-900 dark:text-gray-100'
}
